// extracted by mini-css-extract-plugin
export default {"CompanyLogo":"CompanyLogo_CompanyLogo__ICULh","LogoBtn":"CompanyLogo_LogoBtn__6HB+L"};